<form #detachTrailerForm="ngForm">
  <sc-title>{{'step title' | translate: ['tmc.transport-attach-detach.dialog.step.title.detach-truck',
    translationService.language]}}</sc-title>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <sc-flex>
    <sc-string-field name="trailerNumberPlate"
      [label]="'trailer number plated' | translate: ['tmc.transport-attach-detach.dialog.label.trailerNumberPlate', translationService.language]"
      [required]="true" [(ngModel)]="stepperModel.workingData.trailerNumberPlate" [grow]="true"></sc-string-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-string-field name="swapTrailerNumber"
      [label]="'swap trailer number' | translate: ['tmc.transport-attach-detach.dialog.label.swapTrailerNumber', translationService.language]"
      [(ngModel)]="stepperModel.workingData.swapTrailerNumber" [grow]="true"></sc-string-field>
  </sc-flex>
</form>